import { useEffect, useState } from 'react'
import useLocalStatus from '../../../module/hooks/useLocalStatus/useLocalStatus'
import { IInputStatus } from '../../../interface/progress.interface'

export const useChangeHook = ({
  value,
  name,
  handleChange,
  inputRef,
  status,
  checkChangeValue,
  progressTrigger
}: {
  value: string,
  name: string,
  handleChange: Function,
  inputRef: any,
  status: IInputStatus,
  checkChangeValue: Function,
  progressTrigger?: Function
}) => {

  const [localValue, setLocalValue] = useState<string>(value)
  const [focused, setFocused] = useState<boolean>(false)

  const {
    localStatus,
    changeStatusHandler,
    setChangeStatusHandler
  } = useLocalStatus({
    value: localValue,
    status,
    focused,
    progressTrigger
  })

  useEffect(() => {
    setLocalValue(value)
  }, [value])

  useEffect(() => {
    console.log('useEffect focus', focused)
    if (!focused) {
      inputRef?.current?.blur()
    }
  }, [focused])

  const helpFunc = () => {
    setFocused(false)
    if (progressTrigger) {
      progressTrigger()
    }
  }

  const handleLocalChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const value = event.target.value
      console.log()
      setLocalValue(value)
      setChangeStatusHandler()
      // setLocalStatus(IInputStatus.change)
      checkChangeValue(name)
      // handleChange(name, value, isValidate)
    } catch (error) {
      console.log(error)
    }
  }

  const handleKeydown = (event: any) => {
    console.log(event.key)
    if (event.key === 'Enter') {
      handleChange(name, localValue, true)
      helpFunc()
    } else if (event.key === 'Escape') {
      setLocalValue(value)
      helpFunc()
    }
  }

  const handleBlur = () => {
    console.log('handleBlur', focused)
    if (focused) {
      changeStatusHandler()
      handleChange(name, localValue, true)
      helpFunc()
    }
  }

  return {
    localValue,
    localStatus,
    handleLocalChange,
    handleKeydown,
    handleBlur,
    focused,
    setFocused
  }
}

